import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { IStatusUpdate } from '@vivli/shared/infrastructure/interface';

interface IStatusUpdateContext {
    submitStatusUpdate(): void;
    isSubmittingForm?: boolean;
    formApi?: UseFormReturn<IStatusUpdate>;
    setFormApi: Dispatch<SetStateAction<UseFormReturn<IStatusUpdate>>>;
    isFormDirty?: boolean;
}

export const StatusUpdateContext = createContext<IStatusUpdateContext>(null);

export const useStatusUpdateContext = () => useContext(StatusUpdateContext);
